import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, Book, ClipboardList, Activity, MessageSquare } from 'lucide-react';

/**
 * DashboardMenu - Hamburger menu for switching dashboard tabs
 */
const DashboardMenu = ({
  activeTab,
  setActiveTab,
  menuOpen,
  setMenuOpen,
  menuRef,
}) => {
  const menuItems = [
    { id: 'food-diary', label: 'Food Diary', icon: Book },
    { id: 'food-summary', label: 'My Food Summary', icon: ClipboardList },
    { id: 'biometrics', label: 'Biometrics', icon: Activity },
    { id: 'feedback', label: 'Feedback', icon: MessageSquare },
  ];

  const getActiveTabLabel = () => {
    const item = menuItems.find(i => i.id === activeTab);
    return item ? item.label : 'Menu';
  };

  return (
    <div className="relative" ref={menuRef}>
      <button
        data-testid="menu-toggle"
        onClick={() => setMenuOpen(!menuOpen)}
        className="flex items-center gap-2 px-3 py-2 bg-card rounded-xl border border-border/50 shadow-sm hover:bg-muted/50 transition-colors"
      >
        <Menu className="w-5 h-5 text-primary" />
        <span className="font-medium text-sm hidden sm:inline">
          {getActiveTabLabel()}
        </span>
      </button>
      
      {/* Dropdown Menu */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -10, scale: 0.95 }}
            transition={{ duration: 0.15 }}
            className="absolute top-full left-0 mt-2 w-56 bg-card rounded-xl border border-border shadow-xl z-50 overflow-hidden"
          >
            <div className="p-2">
              {menuItems.map((item) => (
                <button
                  key={item.id}
                  data-testid={`${item.id}-tab`}
                  onClick={() => {
                    setActiveTab(item.id);
                    setMenuOpen(false);
                  }}
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-left font-medium transition-all ${
                    activeTab === item.id
                      ? 'bg-gradient-to-r from-primary to-[#8FD14F] text-white shadow-md'
                      : 'hover:bg-muted text-muted-foreground hover:text-foreground'
                  }`}
                >
                  <item.icon className="w-5 h-5" />
                  {item.label}
                </button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default DashboardMenu;
